import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { THINKING_PHRASES, AI_ASSISTANT } from '@/lib/ai-chat/constants';

const getRandomPhrase = (): string => {
  return THINKING_PHRASES[Math.floor(Math.random() * THINKING_PHRASES.length)];
};

export const ThinkingIndicator: React.FC = () => {
  const [phrase, setPhrase] = useState(getRandomPhrase);

  // Rotate phrase every few seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setPhrase(getRandomPhrase());
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex gap-2 mb-3">
      {/* AI Avatar */}
      <div className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center ring-1 ring-border">
        <img
          src="/media/tag-innovation-logo.png"
          alt={AI_ASSISTANT.name}
          className="h-4 w-4 rounded-sm"
        />
      </div>

      {/* Thinking bubble */}
      <div className="bg-muted rounded-lg px-3 py-2 text-sm">
        <div className="flex items-center gap-2 text-muted-foreground">
          <motion.span
            key={phrase}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
            className="text-sm"
          >
            {phrase}
          </motion.span>
          <div className="flex gap-1">
            {[0, 1, 2].map((i) => (
              <motion.div
                key={i}
                className="w-1.5 h-1.5 rounded-full bg-muted-foreground"
                animate={{
                  opacity: [0.3, 1, 0.3],
                  scale: [0.8, 1, 0.8],
                }}
                transition={{
                  repeat: Infinity,
                  duration: 0.8,
                  delay: i * 0.15,
                  ease: 'easeInOut',
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThinkingIndicator;
